// Currency utilities
export const CURRENCY_OPTIONS = [
  { code: 'USD', symbol: '$', name: 'US Dollar' },
  { code: 'EUR', symbol: '€', name: 'Euro' },
  { code: 'GBP', symbol: '£', name: 'British Pound' },
  { code: 'INR', symbol: '₹', name: 'Indian Rupee' },
  { code: 'AUD', symbol: 'A$', name: 'Australian Dollar' },
  { code: 'CAD', symbol: 'C$', name: 'Canadian Dollar' },
  { code: 'JPY', symbol: '¥', name: 'Japanese Yen' },
  { code: 'CNY', symbol: '¥', name: 'Chinese Yuan' },
  { code: 'CHF', symbol: 'CHF', name: 'Swiss Franc' },
];

export const getCurrencySymbol = (currencyCode = 'USD') => {
  const currency = CURRENCY_OPTIONS.find((c) => c.code === currencyCode);
  return currency?.symbol || '$';
};

export const formatCurrency = (amount, currencyCode = 'USD') => {
  const symbol = getCurrencySymbol(currencyCode);
  const numAmount = parseFloat(amount || 0);
  return `${symbol}${numAmount.toFixed(2)}`;
};

export const getDefaultCurrency = () => {
  try {
    const saved = localStorage.getItem('userCurrency');
    return saved || 'USD';
  } catch (err) {
    return 'USD';
  }
};

export const setDefaultCurrency = (currencyCode) => {
  try {
    localStorage.setItem('userCurrency', currencyCode);
    // Dispatch custom event to notify other components
    window.dispatchEvent(new CustomEvent('currencyChanged', { detail: { currency: currencyCode } }));
  } catch (err) {
    console.error('Error setting currency:', err);
  }
};

export const getTaxRate = () => {
  try {
    const saved = localStorage.getItem('userTaxRate');
    return saved ? parseFloat(saved) : 0;
  } catch (err) {
    return 0;
  }
};

export const setTaxRate = (rate) => {
  try {
    localStorage.setItem('userTaxRate', rate);
    window.dispatchEvent(new CustomEvent('taxRateChanged', { detail: { taxRate: rate } }));
  } catch (err) {
    console.error('Error setting tax rate:', err);
  }
};
